// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 20 20%27%3e%3cpath stroke=%27%236b7280%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%271.5%27 d=%27m6 8 4 4 4-4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.display-board {
  min-height: 100vh;
  padding: 2rem;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  position: relative;
}
.display-board::before {
  content: "";
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(circle at 20% 50%, rgba(120, 119, 198, 0.05) 0%, transparent 50%), radial-gradient(circle at 80% 20%, rgba(255, 119, 198, 0.05) 0%, transparent 50%), radial-gradient(circle at 40% 80%, rgba(120, 219, 226, 0.05) 0%, transparent 50%);
  z-index: -1;
}
.display-board .dashboard-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  animation: fadeInDown 0.8s ease-out;
}
.display-board .dashboard-header .main-dashboard-header {
  width: 100%;
  display: flex;
  flex-direction: column;
}
.display-board .dashboard-header .display-board-expbtn {
  width: 100%;
  display: flex;
  justify-content: end;
}
.display-board .dashboard-header .display-board-expbtn .export-btn {
  cursor: pointer;
  padding: 8px 18px;
  background-color: var(--primary-color);
  color: #fff;
  border: 1px solid var(--primary-color);
  border-radius: 0.5rem;
}
.display-board .dashboard-header h1 {
  font-size: 2rem;
  font-weight: 800;
  background-color: var(--primary-color);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-bottom: 0.5rem;
  letter-spacing: -0.025em;
}
.display-board .dashboard-header p {
  color: #64748b;
  font-size: 1.1rem;
  font-weight: 500;
  opacity: 0.8;
}
.display-board .member-selection {
  margin-top: 1rem;
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  width: fit-content;
}
.display-board .member-selection label {
  font-size: 1rem;
  font-weight: 600;
  color: #374151;
  margin: 0;
  white-space: nowrap;
}
.display-board .member-selection .member-dropdown {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  width: auto;
  min-width: 200px;
  max-width: 280px;
  padding: 8px 12px;
  padding-right: 36px;
  font-size: 0.9rem;
  font-weight: 500;
  color: #374151;
  background-color: #fff;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right 8px center;
  background-repeat: no-repeat;
  background-size: 14px;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  outline: none;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
}
.display-board .member-selection .member-dropdown:hover {
  border-color: #d1d5db;
}
.display-board .member-selection .member-dropdown:focus {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1), 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  transform: translateY(-1px);
}
.display-board .member-selection .member-dropdown:active {
  transform: translateY(0);
}
.display-board .member-selection .member-dropdown:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.display-board .member-selection .member-dropdown:disabled:hover {
  transform: none;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
}
.display-board .member-selection .member-dropdown option {
  padding: 12px 16px;
  font-weight: 500;
  color: #374151;
  background-color: #fff;
}
.display-board .member-selection .member-dropdown option:hover {
  background-color: #f3f4f6;
}
.display-board .member-selection .member-dropdown option:checked {
  background-color: var(--primary-color);
  color: #fff;
}
.display-board .member-selection .member-dropdown option[value=""] {
  color: #9ca3af;
  font-style: italic;
}
.display-board .member-selection.loading {
  position: relative;
}
.display-board .member-selection.loading .member-dropdown {
  opacity: 0.6;
  cursor: not-allowed;
}
.display-board .member-selection.loading .member-dropdown::after {
  content: "";
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  width: 14px;
  height: 14px;
  border: 2px solid #e5e7eb;
  border-top: 2px solid var(--primary-color);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}
.display-board .member-selection.error .member-dropdown {
  border-color: #ef4444;
}
.display-board .member-selection.error .member-dropdown:focus {
  border-color: #ef4444;
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1), 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}
.display-board .loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 50vh;
  color: #64748b;
}
.display-board .loading-container .loading-spinner {
  width: 48px;
  height: 48px;
  border: 4px solid #e2e8f0;
  border-top: 4px solid #3b82f6;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 1rem;
}
.display-board .loading-container p {
  font-size: 1.1rem;
  font-weight: 500;
}
.display-board .widgets-grid {
  display: grid;
  grid-template-columns: 2fr 1fr;
  grid-auto-rows: auto;
  gap: 2rem;
}
.display-board .widgets-grid .widget {
  z-index: 0;
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 12px;
  padding: 0;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  position: relative;
  animation: fadeInUp 0.8s ease-out forwards;
  opacity: 0;
  transform: translateY(40px);
}
.display-board .widgets-grid .widget:hover {
  transform: translateY(-12px) scale(1.02);
  background: rgba(255, 255, 255, 0.95);
}
.display-board .widgets-grid .widget:hover::before {
  opacity: 1;
}
.display-board .widgets-grid .widget:hover .widget-header h3 {
  transform: translateX(8px);
}
.display-board .widgets-grid .widget .widget-header {
  padding: 1rem;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, transparent 100%);
}
.display-board .widgets-grid .widget .widget-header h3 {
  font-size: 1.2rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 0.25rem 0;
  transition: transform 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.75rem;
}
.display-board .widgets-grid .widget .widget-header h3::before {
  content: "";
  width: 8px;
  height: 8px;
  background: linear-gradient(135deg, #3b82f6, #8b5cf6);
  border-radius: 50%;
  box-shadow: 0 0 12px rgba(59, 130, 246, 0.4);
}
.display-board .widgets-grid .widget .widget-header .widget-subtitle {
  color: #64748b;
  font-size: 0.9rem;
  font-weight: 500;
  opacity: 0.8;
}
.display-board .widgets-grid .widget.upcoming-widget {
  grid-column: 1/-1;
}
@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes fadeInUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@media (max-width: 1240px) {
  .display-board {
    padding: 1rem;
  }
  .display-board .dashboard-header h1 {
    font-size: 2rem;
  }
  .display-board .dashboard-header p {
    font-size: 1rem;
  }
  .display-board .member-selection {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
    width: 100%;
  }
  .display-board .member-selection .member-dropdown {
    min-width: 100%;
    padding: 10px 12px;
    padding-right: 36px;
    font-size: 0.95rem;
  }
  .display-board .widgets-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
  .display-board .widgets-grid .upcoming-widget {
    grid-column: 1;
  }
  .display-board .widgets-grid .widget {
    border-radius: 16px;
  }
  .display-board .widgets-grid .widget:hover {
    transform: translateY(-6px);
  }
  .display-board .widgets-grid .widget .widget-header {
    padding: 1.5rem 1.5rem 1rem;
  }
  .display-board .widgets-grid .widget .widget-header h3 {
    font-size: 1.2rem;
  }
}
@media (max-width: 768px) {
  .display-board .member-selection {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
    width: 100%;
  }
  .display-board .member-selection .member-dropdown {
    min-width: 100%;
    padding: 10px 12px;
    padding-right: 36px;
    font-size: 0.95rem;
  }
}
@media (max-width: 480px) {
  .display-board {
    padding: 0.75rem;
  }
  .display-board .dashboard-header h1 {
    font-size: 1.75rem;
  }
  .display-board .member-selection {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
    width: 100%;
  }
  .display-board .member-selection label {
    font-size: 0.85rem;
  }
  .display-board .member-selection .member-dropdown {
    min-width: 100%;
    padding: 8px 10px;
    padding-right: 32px;
    font-size: 0.9rem;
  }
  .display-board .widgets-grid .widget {
    border-radius: 12px;
  }
  .display-board .widgets-grid .widget .widget-header {
    padding: 1.25rem 1.25rem 0.75rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/DisplayBoard/DisplayBoard.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,aAAA;EACA,6DAAA;EACA,kBAAA;AACF;AACE;EACE,WAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,mQAAA;EAGA,WAAA;AADJ;AAIE;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EAEA,mCAAA;AAHJ;AAKI;EACE,WAAA;EACA,aAAA;EACA,sBAAA;AAHN;AAMI;EACE,WAAA;EACA,aAAA;EACA,oBAAA;AAJN;AAMM;EACE,eAAA;EACA,iBAAA;EACA,sCAAA;EACA,WAAA;EACA,sCAAA;EACA,qBAAA;AAJR;AAQI;EACE,eAAA;EACA,gBAAA;EAEA,sCAAA;EACA,qBAAA;EACA,6BAAA;EACA,oCAAA;EACA,qBAAA;EACA,wBAAA;AAPN;AAUI;EACE,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;AARN;AAaE;EACE,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;AAXJ;AAaI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,mBAAA;AAXN;AAcI;EACE,gBAAA;EACA,wBAAA;EACA,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,yDAAA;EACA,qCAAA;EACA,4BAAA;EACA,qBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,iDAAA;EACA,2EAAA;AAZN;AAcM;EACE,qBAAA;AAZR;AAiBM;EACE,kCAAA;EACA,oHACE;EAGF,2BAAA;AAlBR;AAqBM;EACE,wBAAA;AAnBR;AAsBM;EACE,YAAA;EACA,mBAAA;AApBR;AAsBQ;EACE,eAAA;EACA,2EAAA;AApBV;AAyBM;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;AAvBR;AAyBQ;EACE,yBAAA;AAvBV;AA0BQ;EACE,sCAAA;EACA,WAAA;AAxBV;AA6BM;EACE,cAAA;EACA,kBAAA;AA3BR;AAgCI;EACE,kBAAA;AA9BN;AAgCM;EACE,YAAA;EACA,mBAAA;AA9BR;AAgCQ;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,0CAAA;EACA,kBAAA;EACA,kCAAA;AA9BV;AAoCI;EACE,qBAAA;AAlCN;AAoCM;EACE,qBAAA;EACA,mHACE;AAnCV;AA0CE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,cAAA;AAxCJ;AA0CI;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,6BAAA;EACA,kBAAA;EACA,kCAAA;EACA,mBAAA;AAxCN;AA2CI;EACE,iBAAA;EACA,gBAAA;AAzCN;AA6CE;EACE,aAAA;EACA,8BAAA;EACA,oBAAA;EACA,SAAA;AA3CJ;AA6CI;EACE,UAAA;EACA,oCAAA;EACA,2BAAA;EACA,0CAAA;EACA,mBAAA;EACA,UAAA;EACA,qFACE;EAEF,4DAAA;EACA,kBAAA;EAEA,0CAAA;EACA,UAAA;EACA,2BAAA;AA9CN;AA8DM;EACE,wCAAA;EAIA,qCAAA;AA/DR;AAiEQ;EACE,UAAA;AA/DV;AAkEQ;EACE,0BAAA;AAhEV;AAoEM;EACE,aAAA;EAEA,kFAAA;AAnER;AAqEQ;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,+BAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;AAnEV;AAqEU;EACE,WAAA;EACA,UAAA;EACA,WAAA;EACA,qDAAA;EACA,kBAAA;EACA,4CAAA;AAnEZ;AAuEQ;EACE,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;AArEV;AAyEM;EACE,iBAAA;AAvER;AA4EE;EACE;IACE,UAAA;IACA,4BAAA;EA1EJ;EA6EE;IACE,UAAA;IACA,wBAAA;EA3EJ;AACF;AA8EE;EACE;IACE,UAAA;IACA,wBAAA;EA5EJ;AACF;AA+EE;EACE;IACE,uBAAA;EA7EJ;EAgFE;IACE,yBAAA;EA9EJ;AACF;AAiFE;EAxVF;IAyVI,aAAA;EA9EF;EAmFI;IACE,eAAA;EAjFN;EAoFI;IACE,eAAA;EAlFN;EAsFE;IACE,sBAAA;IACA,uBAAA;IACA,WAAA;IACA,WAAA;EApFJ;EAsFI;IACE,eAAA;IACA,kBAAA;IACA,mBAAA;IACA,kBAAA;EApFN;EAwFE;IACE,0BAAA;IACA,SAAA;EAtFJ;EAwFI;IACE,cAAA;EAtFN;EAyFI;IACE,mBAAA;EAvFN;EAyFM;IACE,2BAAA;EAvFR;EA0FM;IACE,2BAAA;EAxFR;EA0FQ;IACE,iBAAA;EAxFV;AACF;AA8FE;EACE;IACE,sBAAA;IACA,uBAAA;IACA,WAAA;IACA,WAAA;EA5FJ;EA8FI;IACE,eAAA;IACA,kBAAA;IACA,mBAAA;IACA,kBAAA;EA5FN;AACF;AAgGE;EA/ZF;IAgaI,gBAAA;EA7FF;EA+FE;IACE,kBAAA;EA7FJ;EAgGE;IACE,sBAAA;IACA,uBAAA;IACA,WAAA;IACA,WAAA;EA9FJ;EAgGI;IACE,kBAAA;EA9FN;EAiGI;IACE,eAAA;IACA,iBAAA;IACA,mBAAA;IACA,iBAAA;EA/FN;EAmGE;IACE,mBAAA;EAjGJ;EAmGI;IACE,gCAAA;EAjGN;AACF","sourcesContent":[".display-board {\n  min-height: 100vh;\n  padding: 2rem;\n  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);\n  position: relative;\n\n  &::before {\n    content: '';\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: radial-gradient(circle at 20% 50%, rgba(120, 119, 198, 0.05) 0%, transparent 50%),\n      radial-gradient(circle at 80% 20%, rgba(255, 119, 198, 0.05) 0%, transparent 50%),\n      radial-gradient(circle at 40% 80%, rgba(120, 219, 226, 0.05) 0%, transparent 50%);\n    z-index: -1;\n  }\n\n  .dashboard-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    // margin-bottom: 1.5rem;\n    animation: fadeInDown 0.8s ease-out;\n\n    .main-dashboard-header {\n      width: 100%;\n      display: flex;\n      flex-direction: column;\n    }\n\n    .display-board-expbtn {\n      width: 100%;\n      display: flex;\n      justify-content: end;\n\n      .export-btn {\n        cursor: pointer;\n        padding: 8px 18px;\n        background-color: var(--primary-color);\n        color: #fff;\n        border: 1px solid var(--primary-color);\n        border-radius: 0.5rem;\n      }\n    }\n\n    h1 {\n      font-size: 2rem;\n      font-weight: 800;\n      // background: linear-gradient(135deg, #1e293b 0%, var(--primary-color) 50%, var(--primary-color) 100%);\n      background-color: var(--primary-color);\n      background-clip: text;\n      -webkit-background-clip: text;\n      -webkit-text-fill-color: transparent;\n      margin-bottom: 0.5rem;\n      letter-spacing: -0.025em;\n    }\n\n    p {\n      color: #64748b;\n      font-size: 1.1rem;\n      font-weight: 500;\n      opacity: 0.8;\n    }\n  }\n\n  // Member Selection Dropdown Styles\n  .member-selection {\n    margin-top: 1rem;\n    margin-bottom: 1rem;\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    width: fit-content;\n\n    label {\n      font-size: 1rem;\n      font-weight: 600;\n      color: #374151;\n      margin: 0;\n      white-space: nowrap;\n    }\n\n    .member-dropdown {\n      appearance: none;\n      -webkit-appearance: none;\n      -moz-appearance: none;\n      width: auto;\n      min-width: 200px;\n      max-width: 280px;\n      padding: 8px 12px;\n      padding-right: 36px;\n      font-size: 0.9rem;\n      font-weight: 500;\n      color: #374151;\n      background-color: #fff;\n      background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e\");\n      background-position: right 8px center;\n      background-repeat: no-repeat;\n      background-size: 14px;\n      border: 2px solid #e5e7eb;\n      border-radius: 8px;\n      outline: none;\n      cursor: pointer;\n      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n      box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);\n\n      &:hover {\n        border-color: #d1d5db;\n        // box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n        // transform: translateY(-1px);\n      }\n\n      &:focus {\n        border-color: var(--primary-color);\n        box-shadow: \n          0 0 0 3px rgba(59, 130, 246, 0.1),\n          0 4px 6px -1px rgba(0, 0, 0, 0.1),\n          0 2px 4px -1px rgba(0, 0, 0, 0.06);\n        transform: translateY(-1px);\n      }\n\n      &:active {\n        transform: translateY(0);\n      }\n\n      &:disabled {\n        opacity: 0.6;\n        cursor: not-allowed;\n        \n        &:hover {\n          transform: none;\n          box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);\n        }\n      }\n\n      // Custom option styling (limited browser support)\n      option {\n        padding: 12px 16px;\n        font-weight: 500;\n        color: #374151;\n        background-color: #fff;\n        \n        &:hover {\n          background-color: #f3f4f6;\n        }\n        \n        &:checked {\n          background-color: var(--primary-color);\n          color: #fff;\n        }\n      }\n\n      // Placeholder option styling\n      option[value=\"\"] {\n        color: #9ca3af;\n        font-style: italic;\n      }\n    }\n\n    // Loading state\n    &.loading {\n      position: relative;\n      \n      .member-dropdown {\n        opacity: 0.6;\n        cursor: not-allowed;\n        \n        &::after {\n          content: '';\n          position: absolute;\n          right: 8px;\n          top: 50%;\n          transform: translateY(-50%);\n          width: 14px;\n          height: 14px;\n          border: 2px solid #e5e7eb;\n          border-top: 2px solid var(--primary-color);\n          border-radius: 50%;\n          animation: spin 1s linear infinite;\n        }\n      }\n    }\n\n    // Error state\n    &.error .member-dropdown {\n      border-color: #ef4444;\n      \n      &:focus {\n        border-color: #ef4444;\n        box-shadow: \n          0 0 0 3px rgba(239, 68, 68, 0.1),\n          0 4px 6px -1px rgba(0, 0, 0, 0.1),\n          0 2px 4px -1px rgba(0, 0, 0, 0.06);\n      }\n    }\n  }\n\n  .loading-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    min-height: 50vh;\n    color: #64748b;\n\n    .loading-spinner {\n      width: 48px;\n      height: 48px;\n      border: 4px solid #e2e8f0;\n      border-top: 4px solid #3b82f6;\n      border-radius: 50%;\n      animation: spin 1s linear infinite;\n      margin-bottom: 1rem;\n    }\n\n    p {\n      font-size: 1.1rem;\n      font-weight: 500;\n    }\n  }\n\n  .widgets-grid {\n    display: grid;\n    grid-template-columns: 2fr 1fr;\n    grid-auto-rows: auto;\n    gap: 2rem;\n\n    .widget {\n      z-index: 0;\n      background: rgba(255, 255, 255, 0.8);\n      backdrop-filter: blur(20px);\n      border: 1px solid rgba(255, 255, 255, 0.3);\n      border-radius: 12px;\n      padding: 0;\n      box-shadow:\n        0 20px 25px -5px rgba(0, 0, 0, 0.1),\n        0 10px 10px -5px rgba(0, 0, 0, 0.04);\n      transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n      position: relative;\n      // overflow: hidden;\n      animation: fadeInUp 0.8s ease-out forwards;\n      opacity: 0;\n      transform: translateY(40px);\n\n      // &::before {\n      //   content: '';\n      //   position: absolute;\n      //   top: 0;\n      //   left: 0;\n      //   right: 0;\n      //   height: 4px;\n      //   background: linear-gradient(90deg, #3b82f6, #8b5cf6, #ec4899);\n      //   opacity: 0;\n      //   transition: opacity 0.3s ease;\n      //   z-index: 1;\n      //   border-radius: 24px 24px 0 0 !important;\n      // }\n\n      &:hover {\n        transform: translateY(-12px) scale(1.02);\n        // box-shadow:\n        //   0 32px 64px -12px rgba(0, 0, 0, 0.15),\n        //   0 20px 25px -5px rgba(0, 0, 0, 0.1);\n        background: rgba(255, 255, 255, 0.95);\n\n        &::before {\n          opacity: 1;\n        }\n\n        .widget-header h3 {\n          transform: translateX(8px);\n        }\n      }\n\n      .widget-header {\n        padding: 1rem;\n        // border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n        background: linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, transparent 100%);\n\n        h3 {\n          font-size: 1.2rem;\n          font-weight: 700;\n          color: #1e293b;\n          margin: 0 0 0.25rem 0;\n          transition: transform 0.3s ease;\n          display: flex;\n          align-items: center;\n          gap: 0.75rem;\n\n          &::before {\n            content: '';\n            width: 8px;\n            height: 8px;\n            background: linear-gradient(135deg, #3b82f6, #8b5cf6);\n            border-radius: 50%;\n            box-shadow: 0 0 12px rgba(59, 130, 246, 0.4);\n          }\n        }\n\n        .widget-subtitle {\n          color: #64748b;\n          font-size: 0.9rem;\n          font-weight: 500;\n          opacity: 0.8;\n        }\n      }\n\n      &.upcoming-widget {\n        grid-column: 1 / -1;\n      }\n    }\n  }\n\n  @keyframes fadeInDown {\n    from {\n      opacity: 0;\n      transform: translateY(-30px);\n    }\n\n    to {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n\n  @keyframes fadeInUp {\n    to {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n\n  @keyframes spin {\n    0% {\n      transform: rotate(0deg);\n    }\n\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n\n  @media (max-width: 1240px) {\n    padding: 1rem;\n\n    .dashboard-header {\n      // margin-bottom: 2rem;\n\n      h1 {\n        font-size: 2rem;\n      }\n\n      p {\n        font-size: 1rem;\n      }\n    }\n\n    .member-selection {\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 0.5rem;\n      width: 100%;\n      \n      .member-dropdown {\n        min-width: 100%;\n        padding: 10px 12px;\n        padding-right: 36px;\n        font-size: 0.95rem;\n      }\n    }\n\n    .widgets-grid {\n      grid-template-columns: 1fr;\n      gap: 1rem;\n\n      .upcoming-widget {\n        grid-column: 1; // Reset to single column behavior\n      }\n\n      .widget {\n        border-radius: 16px;\n\n        &:hover {\n          transform: translateY(-6px);\n        }\n\n        .widget-header {\n          padding: 1.5rem 1.5rem 1rem;\n\n          h3 {\n            font-size: 1.2rem;\n          }\n        }\n      }\n    }\n  }\n\n  @media (max-width: 768px) {\n    .member-selection {\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 0.5rem;\n      width: 100%;\n      \n      .member-dropdown {\n        min-width: 100%;\n        padding: 10px 12px;\n        padding-right: 36px;\n        font-size: 0.95rem;\n      }\n    }\n  }\n\n  @media (max-width: 480px) {\n    padding: 0.75rem;\n\n    .dashboard-header h1 {\n      font-size: 1.75rem;\n    }\n\n    .member-selection {\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 0.5rem;\n      width: 100%;\n\n      label {\n        font-size: 0.85rem;\n      }\n      \n      .member-dropdown {\n        min-width: 100%;\n        padding: 8px 10px;\n        padding-right: 32px;\n        font-size: 0.9rem;\n      }\n    }\n\n    .widgets-grid .widget {\n      border-radius: 12px;\n\n      .widget-header {\n        padding: 1.25rem 1.25rem 0.75rem;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
